angular.module("menus")

    .controller("MenusListCtrl", ['LoginService', '$rootScope', '$scope', '$http', '$interval', '$q', 'Restangular', 'gridService', 'modalService', '$filter', '$state', 'logService',
        function (LoginService, $rootScope, $scope, $http, $interval, $q, Restangular, gridService, modalService, $filter, $state, logService) {
        
        //Comprobamos si tiene permiso escritura
        $scope.allowWrite = LoginService.permissionExist("MENU_WRITE");

        $rootScope.title = $filter('translate')('menus.title');
        $rootScope.breadcrumb = [
            { title: "Lista" }
        ];


        $scope.gridOptions = {
            pdfTitle: $filter('translate')('menus.title'),
            exporterMenuCsv: true,
            enableGridMenu: true,
            rowTemplate: '<div ng-dblclick="grid.appScope.goToEdit(row.entity)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" class="ui-grid-cell" ng-class="col.colIndex()" ui-grid-cell style="cursor:pointer;"></div>',
            paginationPageSizes: [5, 10, 25],
            paginationPageSize: 5,
            onRegisterApi: function (gridApi) {
                this.gridApi = gridApi;
            },
            columnDefs: [
              { name: 'id', visible: false, exporterSuppressExport: true },
              { name: 'name', displayName: $filter('translate')('menus.name'), enableFiltering: true, enableHiding: false },
              { name: 'code', displayName: $filter('translate')('menus.code'), enableFiltering: true },
              {
                  name: ' ', width: 150, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionTemplate([
                      { title: $filter('translate')('menus.edit'), action: 'ui-sref="menus.edit({id:row.entity.id})"', cssIconClass: "fa fa-edit" },
                      { title: $filter('translate')('menus.delete'), action: 'ng-click="grid.appScope.BorrarDialog(row.entity.id,row.entity.name);" ng-if="grid.appScope.allowWrite"', cssIconClass: "fa fa-remove" }
                  ], { cssClass: "pull-right" })
              },              
            ],
            getData: function (options) {
                return Restangular.all('Menus').getList(options);
            }

        };

        $scope.goToEdit = function (rowEntity) {
            $state.go("menus.edit", { id: rowEntity.id });
        }

        $scope.BorrarDialog = function (id, name) {
            $scope.id = id;
            $scope.name = name;
            modalService.confirm({
                title: $filter('translate')('menus.delete'),
                message: $filter('translate')('menus.delete_message')+" " + $scope.name + "?",
                onAccept: function () {
                    Restangular.one('Menus', $scope.id).remove().then(function () {                        
                        $scope.gridOptions.data =
                             $scope.gridOptions.data.filter(function (el) { return el.id != $scope.id; });
                    }, function (response) {
                        logService.error("Error with status code", response.status);
                        alert("Error al borrar")
                    });
                }
            });

        };
        
    }])

;